"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerCell = exports.Td = exports.Tr = exports.Th = exports.TrHead = exports.TBody = exports.THead = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.THead = styled_components_1.default.thead ``;
exports.TBody = styled_components_1.default.tbody ``;
exports.TrHead = styled_components_1.default.tr `
  border-bottom: solid 2px ${({ theme }) => theme.neutral.main};
  border-collapse: collapse;
  position: relative;
  z-index: 1;
`;
exports.Th = styled_components_1.default.th `
  color: ${({ theme }) => theme.text.primary};
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  padding: 0 16px;
  text-align: center;
  white-space: nowrap;
`;
exports.Tr = styled_components_1.default.tr `
  position: relative;
  z-index: 1;

  &:nth-child(even),
  &:nth-child(even) td {
    background-color: ${({ theme }) => theme.neutral.lighter};
  }
  ${({ isActive, theme }) => isActive &&
    (0, styled_components_1.css) `
      &&& td {
        background: ${theme.primary.lighter};
      }
    `}
`;
exports.Td = styled_components_1.default.td `
  color: ${({ theme }) => theme.text.primary};
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
`;
exports.InnerCell = styled_components_1.default.div `
  padding: 8px 16px;
`;
